export enum ChatTab {
  New = "n",
  My = "m",
  Colleagues = "c",
  Archive = "a",
}
